export default "__VITE_ASSET__Dr4lCY9J__"